import React from "react";
import {GlobalAppContextReducerHookInterface} from "../services/exports/Interfaces";

const AppStateContext: React.Context<GlobalAppContextReducerHookInterface> = React.createContext(null);
export default AppStateContext;
